module.exports = __webpack_public_path__ + "img/waterfall-en-2.2c5559e.svg";